import * as React from "react";

const SvgDatasheetIconCalenderRight = props => <svg viewBox="0 0 10 10" xmlSpace="preserve" width="1em" height="1em" {...props}><path d="M9.8 4.5 5.5.2c-.3-.3-.8-.3-1.1 0s-.2.8.1 1.1L8.2 5 4.5 8.7c-.3.3-.3.8 0 1.1.1.1.3.2.5.2s.4-.1.5-.2l4.2-4.2c.4-.4.4-.8.1-1.1z" /></svg>;

export default SvgDatasheetIconCalenderRight;